import api from './api.js';

export const userService = {
  // Parent-child management
  getChildren: (parentId) => api.get(`/users/${parentId}/children`),
  
  // Parent-student requests
  searchStudents: (params) => api.get('/users/search-students', { params }),
  createLinkRequest: (data) => api.post('/users/parent-student-requests', data),
  getMyRequests: () => api.get('/users/parent-student-requests'),
  getRequestById: (id) => api.get(`/users/parent-student-requests/${id}`),
  updateRequest: (id, data) => api.put(`/users/parent-student-requests/${id}`, data),
  cancelRequest: (id) => api.delete(`/users/parent-student-requests/${id}`),
  
  // Get user profile
  getProfile: () => api.get('/users/profile'),
  updateProfile: (data) => api.put('/users/profile', data),
  
  // Get user by ID
  getUserById: (id) => api.get(`/users/${id}`),
  
  // Get users by role
  getUsersByRole: (role, params = {}) => api.get(`/users/by-role/${role}`, { params }),
  
  // User statistics
  getUserStatistics: () => api.get('/users/statistics'),
  
  // Link parent to student (admin only)
  linkParentToStudent: (data) => api.post('/users/parent-student-link', data),
  
  // Get parent's children (alternative endpoint)
  getParentChildren: (parentId) => api.get(`/users/${parentId}/children`),
  
  // Get child details
  getChild: (parentId, childId) => api.get(`/users/${parentId}/children/${childId}`),
  
  // Get child academic records
  getChildAcademicRecords: (parentId, childId) => 
    api.get(`/users/${parentId}/children/${childId}/academic-records`),
  
  // Get child grades
  getChildGrades: (parentId, childId, params = {}) => 
    api.get(`/users/${parentId}/children/${childId}/grades`, { params }),
  
  // Get child attendance
  getChildAttendance: (parentId, childId, params = {}) => 
    api.get(`/users/${parentId}/children/${childId}/attendance`, { params }),
  
  // Get students (for staff/admin)
  getStudents: (params = {}) => api.get('/academic/students', { params }),
  
  // Get student statistics
  getStudentStats: () => api.get('/academic/students/stats'),
};

